import styled, { css } from 'styled-components'

import { Colors } from '@fourthwall/components'

export const ProductSummaryContainer = styled.div`
  padding: 8px 0;
  border-top: 1px solid ${Colors.GS400};
  border-bottom: 1px solid ${Colors.GS400};
`

export const EmptyVariantsNotice = styled.div`
  padding: 16px 0;
`

export const VariantsContainer = styled.div`
  max-height: 350px;
  padding-left: 10px;
  margin-left: -10px;

  overflow: auto;
`

export const VariantContainer = styled.div`
  padding: 20px 0;
  font-size: 16px;
  line-height: 24px;

  & + & {
    border-top: 1px solid ${Colors.GS400};
  }

  &:last-child {
    border-bottom: 1px solid ${Colors.GS400};
  }
`

export const OptionLabel = styled.div<{ disabled: boolean }>`
  display: flex;
  flex: 1;
  justify-content: space-between;

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${Colors.GS600};
    `}
`
